module.exports = __webpack_public_path__ + "static/media/thiery-mugler.5096ca23.jpg";